import React from "react";
import { Row, Col } from "antd";
import TimeFromMidnightItem from "../../../components/forms/TimeFromMidnightItem";
import SwitchItem from "../../../components/forms/SwitchItem";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import FormHeader from "../../../components/forms/FormHeader";
import { InputItem } from "../../../components/forms/FormItems";
import { isAllowedFeature } from "../../organization/organizationSlice";

const ProsectusExport = (props) => {
  const { changedItems, changedValues, activeOrganization } = props;
  const isActive = changedItems.includes("prospectus_export.active")
    ? changedValues["prospectus_export.active"]
    : activeOrganization["prospectus_export"] &&
      activeOrganization["prospectus_export"].active;

  const isAllowed = isAllowedFeature("prospectus_upload");
  if (!isAllowed) return null;

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.organization.prospectusExport" />}
          comp={
            <SwitchItem
              name="prospectus_export.active"
              category="organization"
              hideLabel={true}
              noStyle={true}
            />
          }
        />
        {isActive && (
          <Row>
            <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="prospectus_export.ftp_user"
                    category="organization"
                    required={true}
                    direction={"ltr"}
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="prospectus_export.ftp_password"
                    category="organization"
                    password={true}
                    required={true}
                    direction={"ltr"}
                  />
                </div>
              </ResponsiveItemsWrapper>
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="prospectus_export.ftp_address"
                    category="organization"
                    required={true}
                    domainOrIp={true}
                    direction={"ltr"}
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ flex: 1 }}>
                  <InputItem
                    name="prospectus_export.output_dir"
                    category="organization"
                    required={true}
                    direction={"ltr"}
                  />
                </div>
              </ResponsiveItemsWrapper>
              <ResponsiveItemsWrapper>
                <div style={{ flex: 1 }}>
                  <TimeFromMidnightItem
                    name="prospectus_export.daily_sync_time"
                    category="organization"
                    picker="time"
                    format={"HH:mm"}
                    minuteStep={30}
                  />
                </div>
                <Spacer horizontal={true} />
                <div style={{ flex: 1 }}>
                  <SwitchItem
                    name="prospectus_export.dir_per_branch"
                    category="organization"
                  />
                </div>
              </ResponsiveItemsWrapper>
            </Col>
          </Row>
        )}
      </Surface>
    </div>
  );
};

export default ProsectusExport;
